export class LandedCostRequest {
    currency: string;
    items_amount: number;
    landed_cost: string;
    sale_type: string;
    shipping_amount: number;
    ship_from_country: string;
    ship_to_country: string;
    ship_to_state: string;
    shipping_service_level: string;
}



// WEBPACK FOOTER //
// ./app/objects/zonos/landedCostRequest.ts